export default __webpack_public_path__ + "static/Plots0100-0a9df6b2982dc8218880c9cb6fa53801.jpg";